<div class="contact-card">
    <div class="header">{{ contact.name }}</div>
    <div class="card__actions">
        <div class="actions__email" [class.margin-right-10]="numberOfSelections === 1">
            <ng-container *ngIf="contactEmails?.length === 1; else showEmailDropdown">
                <div class="email__default">
                    {{ contactDisplayedEmail }}
                </div>
            </ng-container>
            <ng-template #showEmailDropdown>
                <!-- NOTE: This is an example of populating a regular dropdown without using onChange or programmatically
                generated values, because the onChange would fire on init (undesirable in this case) -->
                <div class="ui selection fluid dropdown" #emailDropdown>
                    <input type="hidden" name="email" value="{{ contactDisplayedEmail }}" />
                    <div class="default text">{{ contactDisplayedEmail }}</div>
                    <i class="dropdown icon"></i>
                    <div class="menu">
                        <div
                            class="item"
                            *ngFor="let email of contactEmails"
                            [attr.data-value]="email.value"
                            (click)="onEmailDropdownChange(email)"
                        >
                            {{ email.name }}
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>
        <div class="ui icon buttons actions__buttons">
            <button
                *ngIf="numberOfSelections > 1 && !hideVIP"
                class="ui small button icon button--no-background"
                title="Mark invitee as VIP"
                (click)="handleMarkAsVIP(contact.id)"
            >
                <i class="star icon" [ngClass]="{ outline: !isVIP }"></i>
            </button>
            <button class="ui mini button icon button--remove button--full-radius" (click)="handleRemove(contact.id)">
                <i class="icon times"></i>
                <div class="remove__tooltip">Remove</div>
            </button>
        </div>
    </div>
</div>
